
import { defineComponent } from "vue";
import PlanShipmentJournal from "@/components/journals/PlanShipmentJournal/PlanShipmentJournal.vue";

export default defineComponent({
  components: { PlanShipmentJournal },
  props: {
    parentModel: { required: true },
    isCalculation: { required: true },
    isSettingsOpen: { type: Object, required: true },
  },
  methods: {},
  data() {
    return {};
  },
});
